"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presignAvatarSchema = exports.AVATAR_CONTENT_TYPES = exports.AVATAR_MAX_BYTES = void 0;
const zod_1 = require("zod");
exports.AVATAR_MAX_BYTES = 2 * 1024 * 1024;
exports.AVATAR_CONTENT_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
exports.presignAvatarSchema = zod_1.z
    .object({
    contentType: zod_1.z.enum(exports.AVATAR_CONTENT_TYPES),
    contentLength: zod_1.z.number().int().positive().max(exports.AVATAR_MAX_BYTES),
})
    .strict();
//# sourceMappingURL=presign-avatar.schema.js.map